import { Component } from '@angular/core';

@Component({
  selector: 'system-notification',
  templateUrl: './system-notification.component.html',
  styleUrls: ['./system-notification.component.css']
})
export class SystemNotificationComponent {

  systemNotification: any;

  ngOnInit(): void {
    if (localStorage.getItem("SystemNotification")) {
      this.systemNotification = JSON.parse(localStorage.getItem("SystemNotification"));
    }
  }

  CloseNotification(){
    this.systemNotification = null;
  }
}
